<template>
    <div>
        <div class="bg-white p-5 pb-1 mb-3 rounded">
            <!-- Filtros de usuarios -->
            <user-filters
                :clients="clients"
                :empresas="empresas"
                :search="currentSearch"
                :download-url="download"
                @search="handleSearch"
                @filter-changed="handleFilterChange"
                @disable-users="handleDisableUsers"
                @bulk-upload="handleBulkUpload"
                @add-user="handleAddUser">
            </user-filters>

            <!-- Tabla de usuarios -->
            <user-table v-if="!recargatabla"
                :users="users"
                :loading="loading"
                :current-page="currentPage"
                :page-count="pageCount"
                :items-per-page="itemsPerPage"
                :clients="clients"
                :token="token"
                :get="get"
                :rol="rolString"
                :urlvalidateemail="urlvalidateemail"
                :issuperadmin="isSuperAdminBoolean"
                :headertab="headertab"
                :download="download"
                :filters="currentFilters"
                @edit-user="handleEditUser"
                @delete-user="handleDeleteUser"
                @page-change="handlePageChange"
                @reload-table="changeParentVista">
            </user-table>
        </div>

        <!-- Contenedor de creación de usuarios -->
        <create-user-container
            :empresas="empresas"
            :clients="clients"
            :token="token"
            :rol="rolString"
            :get="get"
            :url="url"
            :urlvalidateemail="urlvalidateemail"
            :issuperadmin="isSuperAdminBoolean"
            @user-created="changeParentVista">
        </create-user-container>

        <!-- Modal de edición -->
        <modal-edit-user
            v-if="editingUser"
            :user="editingUser"
            :token="token"
            :empresas="empresas"
            :clients="clients"
            @user-updated="handleUserUpdated"
            @close="editingUser = null">
        </modal-edit-user>

        <!-- Modal de eliminación -->
        <modal-delete-user
            v-if="deletingUser"
            :user="deletingUser"
            :token="token"
            @user-deleted="handleUserDeleted"
            @close="deletingUser = null">
        </modal-delete-user>
    </div>
</template>

<script>
import UserFilters from './UserFilters.vue'
import UserTable from './UserTable.vue'
import CreateUserContainer from './CreateUserContainer.vue'
import ModalEditUser from './ModalEditUser.vue'
import ModalDeleteUser from './ModalDeleteUser.vue'

export default {
    components: {
        UserFilters,
        UserTable,
        CreateUserContainer,
        ModalEditUser,
        ModalDeleteUser
    },
    
    props: ["token", "rol", "get", "clients", "empresas", "urlvalidateemail", "headertab", "issuperadmin", "url", "download"],
    
    data() {
        return {
            recargatabla: false,
            users: [],
            loading: false,
            currentPage: 1,
            pageCount: 1,
            itemsPerPage: 10,
            currentSearch: '',
            currentFilters: {},
            editingUser: null,
            deletingUser: null
        }
    },
    
    computed: {
        // Convertir string a boolean para issuperadmin
        isSuperAdminBoolean() {
            return this.issuperadmin === 'true' || this.issuperadmin === true;
        },
        
        // Convertir array/object a string para rol si es necesario
        rolString() {
            if (typeof this.rol === 'string') return this.rol;
            if (Array.isArray(this.rol) && this.rol.length > 0) {
                // Es un array de objetos de roles, tomar el primer rol
                const firstRole = this.rol[0];
                return firstRole.name || firstRole.rol || firstRole.role || '';
            }
            if (typeof this.rol === 'object' && this.rol !== null) {
                return this.rol.name || this.rol.rol || this.rol.role || '';
            }
            return String(this.rol || '');
        }
    },
    
    methods: {
        changeParentVista(valor) {
            this.recargatabla = valor;
            this.$nextTick(() => {
                this.recargatabla = !valor;
                if (!valor) {
                    this.loadUsers();
                }
            });
        },
        
        handleSearch(searchText) {
            this.currentSearch = searchText;
            this.loadUsers();
        },
        
        handleFilterChange(filters) {
            this.currentFilters = filters;
            this.loadUsers();
        },
        
        handlePageChange(page) {
            this.currentPage = page;
            this.loadUsers();
        },
        
        handleEditUser(user) {
            this.editingUser = { ...user };
        },
        
        handleDeleteUser(user) {
            this.deletingUser = user;
        },
        
        handleUserUpdated(updatedUser) {
            this.editingUser = null;
            this.loadUsers();
        },
        
        handleUserDeleted(deletedUser) {
            this.deletingUser = null;
            this.loadUsers();
        },
        
        handleDisableUsers() {
            // Implementar lógica de deshabilitar usuarios
            console.log('Disable users');
        },
        
        handleBulkUpload() {
            // Implementar lógica de carga masiva
            console.log('Bulk upload');
        },
        
        handleAddUser() {
            // Scroll to create user form
            const createForm = document.getElementById('agregar_administrador');
            if (createForm) {
                createForm.scrollIntoView({ behavior: 'smooth' });
            }
        },
        
        async loadUsers() {
            this.loading = true;
            try {
                const params = {
                    page: this.currentPage,
                    per_page: this.itemsPerPage,
                    search: this.currentSearch,
                    withUsers: true,
                    admin: true,
                    ...this.currentFilters
                };
                
                const response = await axios.get(this.get, {
                    params,
                    headers: {
                        'Authorization': `Bearer ${this.token}`,
                        'Accept': 'application/json'
                    }
                });
                
                if (response.data) {
                    this.users = response.data.data || response.data.users || response.data;
                    this.pageCount = response.data.last_page || Math.ceil((response.data.total || this.users.length) / this.itemsPerPage);
                }
            } catch (error) {
                console.error('Error loading users:', error);
                this.$swal?.fire({
                    title: 'Error!',
                    text: 'No se pudieron cargar los usuarios.',
                    icon: 'error'
                });
            } finally {
                this.loading = false;
            }
        }
    },
    
    mounted() {
        this.loadUsers();
    }
}
</script>

<style>

</style>